import { Link } from "react-router-dom";
import { LOGO_URL } from "../data/site";

// Logotip oficial d'Orbis Forum Català (fons negre). No es modifica; es respecten les proporcions.
export const Brand = ({ variant = "header", className = "" }) => {
  const size = variant === "footer" ? "h-24 md:h-28" : "h-14 md:h-16";
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center ${className}`} aria-label="Orbis Forum Català — Inici">
      <img
        src={LOGO_URL}
        alt="Orbis Forum Català"
        className={`${size} w-auto object-contain select-none`}
        draggable="false"
      />
    </Link>
  );
};
